import { comics } from "@/mocks/comics";

interface ComicInfoProps {
  description: string;
  tags: string[];
  views: string;
  rating: number;
  status: string;
  latestChapter: string;
  updateTime: string;
  cover: string;
  title: string;
}

export default function ComicInfo({
  description,
  tags,
  views,
  rating,
  status,
  latestChapter,
  updateTime,
  cover,
  title,
}: ComicInfoProps) {
  return (
    <section id="comic-content" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-2/3">
            <h2 className="text-xl font-bold text-foreground-950 mb-4">作品简介</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {description}
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-medium text-foreground-600 bg-background-100 px-3 py-1 rounded-full whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-10 md:gap-14">
              <div>
                <p className="text-2xl md:text-3xl font-black text-foreground-950">{views}</p>
                <p className="text-xs text-foreground-400 mt-1">总点击量</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-black text-accent-500">{rating}</p>
                <p className="text-xs text-foreground-400 mt-1">读者评分</p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="relative overflow-hidden rounded-lg aspect-[3/4] max-w-[240px] mx-auto lg:mx-0">
              <img
                src={cover}
                alt={`${title}封面 - 韩漫网`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-white text-foreground-900 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap">
                  {status}
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-white text-sm font-semibold whitespace-nowrap">
                  {latestChapter}
                </p>
                <p className="text-white/70 text-xs whitespace-nowrap">
                  更新于 {updateTime}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}